import { AllowedCountry } from 'types/authentication/Profile'

export const sortCountries = (countries: AllowedCountry[]): AllowedCountry[] => {
  return [...countries].sort((a, b) => a.name.localeCompare(b.name))
}
